import React, { useState } from "react";
import { Grid, Typography, Paper, CircularProgress } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import CustomButton from "../../components/CustomButton";
import { ReactComponent as FailureIcon } from "../../assets/signup/failure.svg";
import { windowHeight, windowWidth } from "../../utils/utils";
import { backendClient } from "../../api/backend";

const PaymentFailedScreen = () => {
    const theme = useTheme();
    const { t } = useTranslation();
    const isDark = theme.palette.mode === "dark";
    const [loading, setLoading] = useState(false);

    const handleUpdatePayment = async () => {
        setLoading(true);
        try {
            const data = await backendClient.getBillingPortalUrl();
            window.location.href = data.portal_url;
        } catch (err) {
            // No Stripe customer yet — create a new Stripe checkout session
            const pendingCheckoutRaw = localStorage.getItem('pendingCheckout');
            const checkout = pendingCheckoutRaw
                ? JSON.parse(pendingCheckoutRaw)
                : { plan: 'starter', billing: 'monthly', region: 'default' };
            try {
                const sessionData = await backendClient.createStripeSession(
                    checkout.plan,
                    checkout.billing,
                    null,
                    checkout.region,
                    checkout.lang || 'auto',
                    checkout.quantity || 1,
                    checkout.currency || null
                );
                window.location.href = sessionData.session_url;
            } catch (stripeErr) {
                setLoading(false);
            }
        }
    };

    return (
        <Grid
            container
            sx={{
                height: "90vh",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: theme.palette.background.default,
            }}
        >
            <Paper
                elevation={isDark ? 0 : 4}
                sx={{
                    borderRadius: "20px",
                    width: "60%",
                    padding: "40px",
                    textAlign: "center",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "60vh",
                    backgroundColor: theme.palette.background.paper,
                    border: isDark ? `1px solid ${theme.palette.divider}` : "none",
                }}
            >
                <FailureIcon
                    style={{
                        width: windowHeight / 2.5,
                        height: windowHeight / 2.5,
                        marginRight: windowWidth / 40,
                        marginBottom: "20px",
                    }}
                />

                <Typography variant="h4" sx={{ mb: 2, color: theme.palette.text.primary }}>
                    {t("payment_failed_title")}
                </Typography>

                <Typography variant="body1" sx={{ mb: 4, color: theme.palette.text.secondary }}>
                    {t("payment_failed_message")}
                </Typography>

                <CustomButton
                    text={loading ? <CircularProgress size={24} color="inherit" /> : t("payment_failed_update_payment")}
                    outlined={false}
                    onClick={handleUpdatePayment}
                    disabled={loading}
                    sx={{ width: "50%", padding: "10px 0" }}
                />
            </Paper>
        </Grid>
    );
};

export default PaymentFailedScreen;
